import React from "react";
import { SEMANTIC_DIV, TEAL_BOX } from "../../../css/styles";
import { Segment } from "semantic-ui-react";

export default function Statistic({
  heading,
  headingTextClass = "h2-text",
  gap = 0,
  stat,
  statFontSize = 31,
  style,
  textAlign = "center",
  vertical = true,
  isLoading = false,
  message = null,
}) {
  return (
    <Segment
      basic
      style={{ ...SEMANTIC_DIV, ...TEAL_BOX, ...style }}
      textAlign={textAlign}
      vertical={vertical}
      loading={isLoading}
    >
      <div className={headingTextClass}>{heading}</div>
      <div style={{ fontSize: statFontSize, fontWeight: 600, marginTop: gap }}>
        {stat}
      </div>
      {message}
    </Segment>
  );
}
